<template>
    <div class="selectbox-question">
        <label v-bind:class="{ error: valid === false, valid: valid === true }"
            ><slot name="label"></slot
        ></label>
        <div class="options">
            <div class="field">
                <select
                    class="form-control"
                    type="text"
                    v-model="currentValue.option"
                    :multiple="multiselect"
                >
                    <option :value="null">
                        {{
                            multiselect
                                ? "Selecione uma ou mais opções"
                                : "Selecione uma opção"
                        }}
                    </option>
                    <option
                        v-for="option in filterOptions"
                        :key="option.order"
                        :value="option"
                    >
                        {{ option.text }}
                    </option>
                </select>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "selectbox-question",
    props: {
        value: {
            type: Object,
            default: () => {
                return {
                    option: [],
                };
            },
        },
        options: {
            type: Array,
            default: () => [
                /*
        {
          removed: false,
          new: false,
          text: "Opção 1",
          order: 1,
        },
        ...
        */
            ],
        },
        multiselect: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        filterOptions() {
            return this.options.filter((op) => op.removed === false);
        },
    },
    data() {
        return {
            currentValue: {
                option: this.multiselect ? [] : null,
            },
            error: null,
            valid: null,
        };
    },
    methods: {
        isValid: function () {
            this.valid = null;
            if (this.isNull()) {
                this.valid = false;
                this.error = "Selecione ao menos uma opção.";
                return false;
            }
            this.valid = true;
            return true;
        },
        getValue: function () {
            if (this.multiselect) {
                return this.currentValue.option.map((op) =>
                    op ? op.text : null,
                );
            }
            return this.currentValue.option
                ? [this.currentValue.option.text]
                : [];
        },
        isNull: function () {
            if (this.multiselect) {
                return (
                    this.currentValue.option.length === 0 ||
                    Object.values(this.currentValue.option).includes(null)
                );
            }
            return !this.currentValue.option || !this.currentValue.option.text;
        },
    },
    watch: {
        "currentValue.option"() {
            this.isValid();
            this.$emit("change", this.getValue());
        },
    },
};
</script>
